import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { NavBar } from './components/Navbar';
import { Closed } from './pages/closed';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <NavBar />
      </header>
      <Router>
        <Routes>
          {/* <Route path="/" element={<Success />} /> */}
          {/*<Route path="/" element={<Home />} />*/}
          {/*<Route path="/success" element={<Success />} />*/}
          {/*<Route path="/failure" element={<Error />} />*/}
          {/*<Route path="/expired" element={<Expired />} />*/}
          {/*<Route path='*' element={<NotFound />} />*/}
          <Route path="/" element={<Closed />} />
          <Route path="/success" element={<Closed />} />
          <Route path="/failure" element={<Closed />} />
          <Route path="/expired" element={<Closed />} />
          <Route path='*' element={<Closed />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
